import { getApps, initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import {
  connectFirestoreEmulator,
  initializeFirestore,
  memoryLocalCache,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { EMULATOR_PORTS, FUNCTIONS_REGION } from '@shared/config';
import { readFirebaseConfig } from './read-firebase-config';

const config = readFirebaseConfig(import.meta.env as unknown as Record<string, string | undefined>);
export const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';

export const app = getApps()[0] ?? initializeApp(config);
export const auth = getAuth(app);

const canPersist = typeof window !== 'undefined' && 'indexedDB' in window;
export const db = initializeFirestore(app, {
  localCache: canPersist ? persistentLocalCache({ tabManager: persistentMultipleTabManager() }) : memoryLocalCache(),
});
export const storage = getStorage(app);
export const functions = getFunctions(app, FUNCTIONS_REGION);

if (useEmulators) {
  connectAuthEmulator(auth, `http://127.0.0.1:${EMULATOR_PORTS.auth}`, { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', EMULATOR_PORTS.firestore);
  connectStorageEmulator(storage, '127.0.0.1', EMULATOR_PORTS.storage);
  connectFunctionsEmulator(functions, '127.0.0.1', EMULATOR_PORTS.functions);
}

export async function initAnalytics(): Promise<void> {
  if (!import.meta.env.PROD || !config.measurementId || useEmulators) return;
  const { getAnalytics, isSupported } = await import('firebase/analytics');
  if (await isSupported()) getAnalytics(app);
}
